import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// =============================================================================
//  Copyright : 2021 semantics GmbH
//  Date      : $Date: 2026-02-04 21:02:19 +0100 (Wed, 04 Feb 2026) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 160321 $
//  Purpose   : gndo parts
// =============================================================================
// ---Third-party imports
import React from 'react';
import { Icon } from 'semantic-ui-react';
// ---Framework imports
import { dict, mapItems } from 'ldash';
import { Sel } from 'uix/registries';
import log from 'uix/logging';
import { HeaderSegment, Editor, XMenu } from 'uix/components';
import { MIME, formatDateTime } from 'uix/utils';
import { JobMenuButton } from 'uix/job/components';
import { useApi, usePhysicalNode, useResettableState, useCallApi } from 'uix/hooks';
import { loadLazy, funcPart } from 'uix/parts';
// ---Exports
// ---Globals
export const GndoResource = ({})=>{
    let node = usePhysicalNode();
    let { data, error, loading, reload } = useApi('gndo/getCode', {
        otid: node.otid,
        datatypeName: node.datatypeName
    }, {
        autoreset: false
    });
    let [text, setText] = useResettableState(null, [
        data,
        node
    ]);
    if (text === null) {
        text = data?.gndo;
    }
    let { callApi, calling } = useCallApi('gndo/saveCode');
    let modified = text !== null && text !== data?.gndo;
    let save = ()=>callApi({
            otid: node.otid,
            text
        }, reload);
    let jobname = 'GndUpdate';
    if (node.datatypeName == 'glossary') {
        jobname = 'GlossaryUpdate';
    }
    let menu = /*#__PURE__*/ _jsxs(XMenu, {
        children: [
            /*#__PURE__*/ _jsx(XMenu.Item, {
                icon: "save",
                disabled: !modified,
                onClick: save
            }),
            /*#__PURE__*/ _jsx(JobMenuButton, {
                name: jobname,
                label: "Update",
                params: {
                    ids: [
                        node.otid
                    ]
                }
            })
        ]
    });
    let subheader = formatDateTime(data?.updatets);
    return /*#__PURE__*/ _jsx(HeaderSegment, {
        icon: "file outline",
        header: "GNDO",
        subheader: subheader,
        flex: true,
        menu: menu,
        loading: loading || calling,
        children: /*#__PURE__*/ _jsx(Editor, {
            flex: true,
            mimetype: MIME.XML,
            text: text,
            extraKeys: {
                'Ctrl-S': save
            },
            onBeforeChange: ({ value })=>setText(value)
        })
    });
};
export const GndoResourceLobId = ({})=>{
    let node = usePhysicalNode();
    let { data, error, loading } = useApi('gndo/getLiveInfo', {
        otid: node.otid
    });
    let text = JSON.stringify(data?.gndo, null, 2);
    return /*#__PURE__*/ _jsx(HeaderSegment, {
        icon: "file outline",
        header: "GNDO",
        flex: true,
        children: /*#__PURE__*/ _jsx(Editor, {
            flex: true,
            mimetype: MIME.JSONLD,
            text: text
        })
    });
};
export const GndoForcegraph = loadLazy(()=>import(/* webpackChunkName: 'gndo' */ './graph'));
export const GndoMap = loadLazy(()=>import(/* webpackChunkName: 'gndo_map' */ './map'));
